import { render, staticRenderFns } from "./GroupChatApp.vue?vue&type=template&id=7c9b927c"
import script from "./GroupChatApp.vue?vue&type=script&lang=js"
export * from "./GroupChatApp.vue?vue&type=script&lang=js"
import style0 from "./app.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports